import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {OrderAddressProps, OrderProps, OrderTypeEnum} from '../types';
import ordersKeys from '../util/orders-keys';
import {CartPaymentProps} from 'modules/cart/types';
import useCart from 'modules/cart/util/use-cart';
import {CreateOrderProductProps} from './use-create-order';

export interface UpdateOrderProps {
  payment: CartPaymentProps;
  products: CreateOrderProductProps[];
  type: OrderTypeEnum;
  address?: OrderAddressProps;
  total: number;
  document?: string;
  deliveryPrice: number;
  deliveryManFee: number;
  freeDelivery: boolean;
  observation?: string;
  retainedEarnings?: boolean;
}

const useUpdateOrder = (orderId: string) => {
  const {create} = useInfiniteQueryHelpers();
  const {clearCart} = useCart();

  const onSuccess = (data: OrderProps) => {
    create(ordersKeys.list(), data);
    clearCart();
  };

  return useApiMutation<UpdateOrderProps>({
    url: `/orders/${orderId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar pedido',
    successTitle: 'Alterar pedido',
    successMessage: 'Pedido alterado com sucesso',
    redirectUrl: `/orders/${orderId}`,
    onSuccess,
  });
};

export default useUpdateOrder;
